import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";
import {getDeviseSymbol} from "../../../../../i18n";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const teams=Array.isArray(campagneData?.teams)?campagneData.teams:[]

    let total=0
    for(let t of teams){
        if(t.objectif){
            total+=t.objectif
        }
    }

    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=_objectif>0 ? (total/_objectif)*100 : 0
    const displayPercent=Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor=campagneData.config?.secondaryColor || "#000"

    let donorName=campagneData.config?.donorName || "Parrainages"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })


    if(mini)
    {
        return (
            <div style={{marginTop: "8vh",display:"flex",flexDirection:"column",alignItems:"center"}}>
                <span className={"screen-count-text"} style={{textAlign:"center"}}><Counter number={total} decimals={0} preserveValue/>{getDeviseSymbol(context)}</span>

                <div style={{display: "flex", gap: "10%", marginBottom: "2vh", width: "90%", justifyContent: "center"}}>
                <span style={{
                    color: '#FFF',
                    fontSize: "4vh",
                    textTransform: "uppercase",
                }}>{teams.length} Ambassadeurs</span>
                </div>
            </div>
        )
    }


    return (
        <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 10}}>

            <div>
                <span className={"screen-count-text2"} style={{marginTop: "-5vh",textAlign:"center"}}><Counter number={total} decimals={0}
                                                                                            preserveValue/>{getDeviseSymbol(context)}</span>
            </div>

            <div style={{display: "flex", gap: "10%", marginBottom: "2vh", width: "90%", justifyContent: "center"}}>
                <span style={{
                    color: '#FFF',
                    fontSize: "4vh",
                    textTransform: "uppercase",
                }}>{teams.length} Ambassadeurs</span>
            </div>

            <ProgressBar
                customLabel={<span style={{fontSize: "3.5vh", marginRight: "1vw"}}><Counter number={displayPercent}
                                                                                            decimals={0}/>%</span>}
                animateOnRender
                completed={percent >= 10 ? percent : 10}
                width={"70vw"}
                height={"7vh"}
                bgColor={"linear-gradient(90deg, rgba(220,171,107,1) 30%, rgba(255,230,197,1) 100%)"}
                baseBgColor={"rgba(255,255,255,0.2)"}
                labelColor={progressLabelColor}
                className="screen-progress-bar"
            />

            <div style={{display: "flex", gap: "10%", marginTop: "2vh", width: "90%", justifyContent: "center"}}>
                <span style={{
                    color: '#FFF',
                    fontSize: "4vh",
                    textTransform: "uppercase",
                }}>{!bonus && "OBJECTIF"} {bonus && "NOUVEL OBJECTIF"} : {formater.format(_objectif)}{getDeviseSymbol(context)}</span>
            </div>

        </div>
    )
}
